import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";

import i18n from "../../../translations/i18n";
import {
  SEARCH_RESULT_SHAPE,
  SEARCH_RESULT_ARTIST_KIND,
  SEARCH_RESULT_POST_KIND,
  SEARCH_RESULT_PAINTING_KIND,
  SEARCH_RESULT_NAMES,
  SEARCH_RESULT_PLURALIZE_NAMES,
} from "../../../constants/searchConstants";
import Artist from "../item/artist";
import Painting from "../item/painting";
import Post from "../item/post";
import Empty from "../../../components/ui/empty";
import {COLLECTION_FETCH_STATUS_SHAPE} from "../../../selectors/collections";
import Link from "../../ui/link";

class List extends Component {

  constructor(props) {
    super(props);
  }

  preparedItems() {
    const items = this.props.items || [];
    return Object.groupBy(items, (item) => item.searchable.kind);
  }

  facetCount(kind) {
    return this.props.facets.find((facet) => facet.type === kind)?.count || 0;
  }

  kindLabel(kind, count) {
    return this.pluralize(count, ...(SEARCH_RESULT_PLURALIZE_NAMES[kind] || []));
  }

  pluralize(count, one, few, many) {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
      return one;
    } else if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
      return few;
    } else {
      return many;
    }
  }

  renderItem(item, key) {
    return <Fragment key={key}>
      {item.searchable.kind === SEARCH_RESULT_ARTIST_KIND &&
        <Artist item={item.searchable}/>
      }

      {item.searchable.kind === SEARCH_RESULT_PAINTING_KIND &&
        <Painting item={item.searchable}/>
      }

      {item.searchable.kind === SEARCH_RESULT_POST_KIND &&
        <Post item={item.searchable}/>
      }
    </Fragment>
  }

  render () {
    const { q, fetchStatus, items } = this.props;
    const defaultSearchPath = `/search?q=${q}&page=1`;

    return (
      <>
        { isEmpty(items) && !fetchStatus.isFetching
          ? <div className="p-search__results-fail">
              <span>
                <Empty message={isNil(q) ? i18n.t("pages.search.empty.title") : i18n.t("pages.search.not_found.title")} />
              </span>
            </div>
          : <div className="p-search__results-list">
              {this.props.currentType ? (
                (items || []).map((item) => this.renderItem(item, item.id))
              ) : (
                Object.entries(this.preparedItems()).map(([kind, items]) => {
                  if (!items.length) return null;

                  const count = this.facetCount(kind);

                  return (
                    <Fragment key={kind}>
                      <div className="p-search__results-type">
                        <strong>{SEARCH_RESULT_NAMES[kind]}</strong>
                      </div>

                      {items.map((item, i) => this.renderItem(item, item.id + kind + i))}

                      {count > items.length && (
                        <Link to={`${defaultSearchPath}&type=${kind}`}>
                          {`Посмотреть все ${count} ${this.kindLabel(kind, count)}`}
                        </Link>
                      )}
                    </Fragment>
                  );
                })
              )}
          </div>
        }
      </>
    )
  }
}

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(SEARCH_RESULT_SHAPE)),
  q: PropTypes.string,
  fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
};

export default List;
